<template>
    <div class="activity-card">
        <div
            v-if="activitiesCompleted.length > 0"
            :id="`${cellId}_completed`"
            tabindex="0"
            class="activity-card-area alert alert-secondary"
            role="alert"
            style="position: relative;"
        >
            <span class="activity-card-span">
                {{ activitiesCompleted.length }}
            </span>
            <div
                v-if="showCheckmark(activitiesCompleted)"
                class="custom-checkbox disabled"
            >
                <i class="fas fa-check"></i>
            </div>
            <activity-list-group
                :treatment="treatment"
                :target="`${cellId}_completed`"
                :activities="activitiesCompleted"
                :prepareDateTime="prepareDateTime"
                :dialogs="dialogs"
                :parentRef="parentRef"
                :labelOptions="labelOptions"
            >
            </activity-list-group>
        </div>
        <div
            v-if="activitiesOverdue.length > 0"
            :id="`${cellId}_overdue`"
            tabindex="0"
            class="activity-card-area alert alert-danger"
            role="alert"
        >
            <span class="activity-card-span">
                {{ activitiesOverdue.length }}
            </span>
            <activity-list-group
                :treatment="treatment"
                :target="`${cellId}_overdue`"
                :activities="activitiesOverdue"
                :prepareDateTime="prepareDateTime"
                :dialogs="dialogs"
                :parentRef="parentRef"
                :labelOptions="labelOptions"
            >
            </activity-list-group>
        </div>
        <div
            v-if="activeActivities.length > 0"
            :id="`${cellId}_active`"
            tabindex="0"
            class="activity-card-area alert alert-light border border-dark"
            role="alert"
        >
            <span class="activity-card-span">
                {{ activeActivities.length }}
            </span>
            <activity-list-group
                :treatment="treatment"
                :target="`${cellId}_active`"
                :activities="activeActivities"
                :prepareDateTime="prepareDateTime"
                :dialogs="dialogs"
                :parentRef="parentRef"
                :labelOptions="labelOptions"
            >
            </activity-list-group>
        </div>
    </div>
</template>
<script>
import ScheduleHelper from "../helper";
import TreatmentActivityMixin from "@/mixins/treatment-activity-details";

export default {
    name: "PatientTreatmentDetailsCard",
    components: {
        ActivityListGroup: () => import("./treatment-activity-list-popover")
    },
    mixins: [ScheduleHelper, TreatmentActivityMixin],
    props: {
        treatment: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        activities: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        cellId: {
            type: String,
            default: "cell"
        },
        cellDate: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        prepareDateTime: {
            type: Function
        },
        parentRef: {
            type: HTMLDivElement,
            default() {
                return null;
            }
        },
        labelOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            isChecked: true,
            activitiesCompleted: [],
            activitiesOverdue: [],
            activeActivities: []
        };
    },
    watch: {
        activities: {
            handler(value) {
                this.activitiesCompleted = value.filteredCompletedActivities;
                this.activitiesOverdue = value.filteredOverdueActivities;
                this.activeActivities = value.filteredActiveActivities;
            },
            immediate: true // Trigger the handler on initial load
        }
    },
    methods: {
        showCheckmark(activities) {
            return !activities.some(
                activity =>
                    activity.actualStatus == "incomplete" ||
                    activity.actualStatus == "deactivated"
            );
        }
    }
};
</script>
<style scoped>
.activity-card {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
    justify-content: flex-start; /* justify-content-start */
    align-items: center; /* align-items-center */
    height: 100%; /* h-100 */
}
.activity-card-area {
    width: -webkit-fill-available;
    display: flex; /* d-flex */
    align-items: center; /* align-items-center */
    margin-bottom: 0; /* mb-0 */
    height: 100%; /* h-100 */
    border-radius: 0px;
    cursor: pointer;
}
.activity-card-span {
    display: flex; /* d-flex */
    justify-content: center; /* justify-content-center */
    flex: 1 1 auto; /* flex-fill */
    font-size: larger;
}
/* Base styles for the custom checkbox */
.custom-checkbox {
    width: 16px; /* Size of the checkbox */
    background-color: #fff; /* Default background color */
    border: 2px solid #ccc; /* Default border color */
    border-radius: 2px; /* Optional: Rounded corners */
    position: absolute;
    top: -1px;
    right: -1px;
    cursor: pointer; /* Pointer cursor for interactive checkboxes */
    text-align: center;
    line-height: 10px; /* Center the icon */
}

/* Disabled state */
.custom-checkbox.disabled {
    background-color: gray; /* Darker gray for disabled state */
    border-color: gray; /* Darker border for disabled state */
    cursor: pointer; /* Show a disabled cursor */
}

/* Icon styles */
.custom-checkbox i {
    font-size: 10px; /* Adjust icon size */
    color: white; /* Inherit text color from the parent */
}
</style>
